export default __webpack_public_path__ + "static/media/host_naviLogout.b2381923.svg";